import { render, staticRenderFns } from "./AutomationElementList.vue?vue&type=template&id=45087165&scoped=true"
import script from "./AutomationElementList.vue?vue&type=script&lang=js"
export * from "./AutomationElementList.vue?vue&type=script&lang=js"
import style0 from "./AutomationElementList.vue?vue&type=style&index=0&id=45087165&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45087165",
  null
  
)

export default component.exports